import React from "react";
import { useSelector } from "react-redux";
import ErrorPopup from "../Popup/ErrorPopup";
import RootState from "../../redux/types/rootState";

const ErrorManager = () => {
  const error = useSelector((state: RootState) => state.bookings.error);
  const [isPopupOpen, setIsPopupOpen] = React.useState(false);

  React.useEffect(() => {
    if (error) {
      setIsPopupOpen(true);
    }
  }, [error]);

  const handleClose = () => {
    setIsPopupOpen(false);
  };

  return (
    <div>
      {isPopupOpen && (
        <ErrorPopup error={error!} onClose={handleClose} isOpen={isPopupOpen} />
      )}
    </div>
  );
};

export default ErrorManager;
